import React from 'react';
import { createStyles } from "./styles";





var BrowsingCriteriaBlock = function BrowsingCriteriaBlock(_ref)


{var shortName = _ref.shortName,bcWidth = _ref.bcWidth;
  var classes = createStyles(bcWidth);
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.bcBlock }, /*#__PURE__*/
    React.createElement("p", { className: classes.shortName }, shortName)));


};

export default BrowsingCriteriaBlock;
//# sourceMappingURL=index.js.map